var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15C16.4834 15 17.9334 14.5601 19.1668 13.736C20.4001 12.9119 21.3614 11.7406 21.9291 10.3701C22.4968 8.99968 22.6453 7.49168 22.3559 6.03683C22.0665 4.58197 21.3522 3.2456 20.3033 2.1967C19.2544 1.14781 17.918 0.433503 16.4632 0.144114C15.0083 -0.145275 13.5003 0.00324964 12.1299 0.570907C10.7594 1.13856 9.58809 2.09986 8.76398 3.33323C7.93987 4.56659 7.5 6.01664 7.5 7.5C7.50199 9.48852 8.2928 11.395 9.69889 12.8011C11.105 14.2072 13.0115 14.998 15 15ZM15 2.5C15.9889 2.5 16.9556 2.79325 17.7779 3.34265C18.6001 3.89206 19.241 4.67296 19.6194 5.58659C19.9978 6.50022 20.0969 7.50555 19.9039 8.47545C19.711 9.44536 19.2348 10.3363 18.5355 11.0355C17.8363 11.7348 16.9454 12.211 15.9755 12.4039C15.0055 12.5969 14.0002 12.4978 13.0866 12.1194C12.173 11.741 11.3921 11.1001 10.8427 10.2779C10.2932 9.45561 10 8.48891 10 7.5C10 6.17392 10.5268 4.90215 11.4645 3.96447C12.4021 3.02679 13.6739 2.5 15 2.5Z",
    fill: "#0B3F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5C12.0173 17.5033 9.15777 18.6896 7.0487 20.7987C4.93964 22.9078 3.75331 25.7673 3.75 28.75C3.75 29.0815 3.8817 29.3995 4.11612 29.6339C4.35054 29.8683 4.66848 30 5 30C5.33152 30 5.64946 29.8683 5.88388 29.6339C6.1183 29.3995 6.25 29.0815 6.25 28.75C6.25 26.4294 7.17187 24.2038 8.81281 22.5628C10.4538 20.9219 12.6794 20 15 20C17.3206 20 19.5462 20.9219 21.1872 22.5628C22.8281 24.2038 23.75 26.4294 23.75 28.75C23.75 29.0815 23.8817 29.3995 24.1161 29.6339C24.3505 29.8683 24.6685 30 25 30C25.3315 30 25.6495 29.8683 25.8839 29.6339C26.1183 29.3995 26.25 29.0815 26.25 28.75C26.2467 25.7673 25.0604 22.9078 22.9513 20.7987C20.8422 18.6896 17.9827 17.5033 15 17.5Z",
    fill: "#0B3F37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.96394736f7d7740b0d295b9293f1ae73.svg";
export { ForwardRef as ReactComponent };